import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthService from '../services/authService'
import Agenda from '../views/Agenda.vue'
//import AgendamentoAdmin from '../views/AgendamentosAdmin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'agenda',
    component: Agenda,
    meta:{
      title: 'Agenda Saúde',
      requirestAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login'),
    meta:{
      title: 'Agenda Saúde | Login',
      requirestAuth: false
    }
  },
  {
    path: '*',
    redirect:'/'
  },
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuth = AuthService.isAuthenticated()
  if (to.meta.requirestAuth){
    document.title = to.meta.title
    
    if (isAuth){
      next()
    }else{
      next({name:'login'})
    }
  }else{
    if (isAuth && to.name == 'login'){
      next({name:'agenda'})
    }
  }
  next();
});

export default router
